import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-opacity": ".6",
      "stroke-width": "2",
      d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16Z"
    }, null, -1 /* HOISTED */)
  ])))
}
export default { render: render }